import React, { useState, useEffect } from "react";
import { Dialog, Classes, Icon, Intent } from "@blueprintjs/core";
import style from "./../index.module.scss";
import { Radio, Switch, makeStyles } from "@material-ui/core";
import WritingFile from "./../../../images/writing-file.svg";
import { Box, Divider } from "@mui/material";
import { POST, GET, PUT } from "./../../dataSaver";
import { ErrorToaster, SuccessToaster } from "../../../utils/toaster";
import Editor from "../common/Editor";
import FormControlLabel from "@mui/material/FormControlLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MarkdownEditor from "../../../Components/MarkdownEditor";
import { TextField } from "@mui/material";
import CommonInputField from "../../../Components/CommonFields/CommonInputField";

const useStyles = makeStyles({
  switch: {
    "& .Mui-checked": {
      color: "#06617A",
    },
    "& .MuiSwitch-track": {
      backgroundColor: "#06617A !important",
    },
  },
});

const StaffPrivilegeDialog = ({
  open,
  handleClose, //with needRefetch param as optional
  isEdit,
  selectedApplicant,
}) => {
  const [isPrivilagesRequired, setPrivilagesRequired] = useState(false);
  const [applicantTypes, setApplicantTypesState] = useState([]);
  const [sites, setSitesState] = useState([]);
  const [departments, setDepartmentsState] = useState([]);
  const [generalInstructionContent, setGeneralInstructionContent] = useState();
  const [advancePrivilegeContent, setAdvancePrivilegeContent] = useState();
  const [privilegeSpecificationType, setPrivilegeSpecificationType] =
    useState("");
  const [saveData, setSaveData] = useState({});
  const [isProofOfDocumentRequired, setIsProofOfDocumentRequired] =
    useState(false);
  const [aliasName1, setAliasName1] = useState("");
  const [aliasName2, setAliasName2] = useState("");
  const [writtenNotice, setWrittenNotice] = useState(false);
  const [advancedSwitch, setAdvancedSwitch] = useState(false);
  const [evidenceRequired, setEvidenceRequired] = useState(false);
  const [competencyRequired, setCompetencyRequired] = useState(false);
  const [showCard, setShowCard] = useState(false);

  const PrivilegeSpecificationType1 = "DescriptiveDocument";
  const PrivilegeSpecificationType2 = "DiscreteItemList";

  const privilegeSpecifications = [
    {
      id: "Descriptive_Document",
      value: PrivilegeSpecificationType1,
      label: "Descriptive Document",
    },
    {
      id: "Discreet_Item_List",
      value: PrivilegeSpecificationType2,
      label: "Discreet Item List",
    },
  ];

  const classes = useStyles();

  const updateSaveData = (property, data) => {
    setSaveData((prev) => ({ ...prev, [property]: data }));
  };

  const handlePrivilegeSpecificationChange = (event) => {
    setPrivilegeSpecificationType(event.target.value);
    setIsProofOfDocumentRequired(false);
  };

  useEffect(() => {
    if (selectedApplicant) {
      setSaveData({ ...selectedApplicant });
      setPrivilegeSpecificationType(
        selectedApplicant.privilegeSpecificationType
      );
      setIsProofOfDocumentRequired(
        selectedApplicant.proofOfDocumentationRequired
      );
      setPrivilagesRequired(selectedApplicant.advancedPrivilegesRequired);
      setGeneralInstructionContent(selectedApplicant.generalInstructionText);
      setAdvancePrivilegeContent(selectedApplicant.advancedInstructionText);
    }
  }, [selectedApplicant]);

  useEffect(() => {
    fetchApplicantTypes();
    fetchSpecificSites();
    fetchDepartments();
  }, []);

  const fetchApplicantTypes = async () => {
    try {
      const response = await GET("entity-service/applicantType");
      const applicantTypes = response.data.map((item) => ({
        id: item.id,
        type: item.applicantType,
      }));

      if (applicantTypes && applicantTypes.length > 0) {
        setApplicantTypesState(applicantTypes);
      }
    } catch (error) {
      console.error("Error fetching applicant types:", error);
    }
  };

  const fetchDepartments = async () => {
    try {
      const response = await GET("entity-service/department");
      const departmentNames = response.data.map((item) => ({
        id: item.id,
        name: item.departmentName.name,
      }));
      if (departmentNames && departmentNames.length) {
        setDepartmentsState(departmentNames);
      }
    } catch (error) {
      console.error("Error fetching applicant types:", error);
    }
  };

  const fetchSpecificSites = async () => {
    try {
      const response = await GET("entity-service/sites");
      // Ensure that response.data is an array and handle any potential issues
      if (Array.isArray(response.data)) {
        const specificSites = response.data.map((site) => ({
          id: site.id,
          name: site.siteName ? site.siteName.siteName : "Unknown", // Safely access nested properties
        }));

        setSitesState(specificSites);
      } else {
        console.error("Unexpected response format:", response.data);
      }
    } catch (error) {
      console.error("Error fetching specific sites:", error);
    }
  };

  const handleDepartmentChange = (e) => {
    var departmentData = {
      id: e.target.value,
      departmentName: {
        name: departments.find((item) => item.id == e.target.value).name,
      },
    };
    setSaveData((prev) => ({
      ...prev,
      department: departmentData,
    }));
  };

  const handleApplicantTypeChange = (e) => {
    var applicantData = {
      id: e.target.value,
      applicantType: applicantTypes.find((item) => item.id == e.target.value)
        .type,
    };
    setSaveData((prev) => ({
      ...prev,
      applicantType: applicantData,
    }));
  };

  const handleSelectSiteChange = (e) => {
    var selectedIds = e.target.value;
    if (selectedIds) {
      setSaveData((prev) => ({
        ...prev,
        sites: selectedIds.map((item) => {
          return {
            id: item,
          };
        }),
      }));
    }
  };

  const SaveSubmitHandler = async (isSaveAndExit) => {
    var staffPrivileges = {
      ...saveData,
      proofOfDocumentationRequired: isProofOfDocumentRequired,
      advancedPrivilegesRequired: isPrivilagesRequired,
      privilegeSpecificationType: privilegeSpecificationType,
    };

    if (!isEdit) {
      await POST(
        "entity-service/staffPrivilege",
        JSON.stringify(staffPrivileges)
      )
        .then((response) => {
          SuccessToaster("Staff Privilege Added Successfully");
          resetDialogFields();
          if (isSaveAndExit) {
            handleClose(true);
          }
        })
        .catch((error) => {
          ErrorToaster(error);
        });
    } else {
      var id = selectedApplicant.id;
      await PUT(
        `entity-service/staffPrivilege/${id}`,
        JSON.stringify(staffPrivileges)
      )
        .then((response) => {
          SuccessToaster("Staff Privilege Updated Successfully");
          resetDialogFields();
          if (isSaveAndExit) {
            handleClose(true);
          }
        })
        .catch((error) => {
          ErrorToaster(error);
        });
    }
  };

  const resetDialogFields = () => {
    setSaveData({});
    setPrivilegeSpecificationType("");
    setIsProofOfDocumentRequired(false);
    setPrivilagesRequired(false);
    setGeneralInstructionContent("");
    setAdvancePrivilegeContent("");
  };

  const handleAddMoreClick = () => {
    setShowCard(true);
  };

  return (
    <Dialog
      isOpen={open}
      className={`${style.healthCareDialogStyle} ${style.dialogPaddingBottom}`}
    >
      <div
        className={`${Classes.DIALOG_BODY} ${style.extensionDialogBackground}`}
      >
        <div className={style.spaceBetween}>
          <p className={style.extensionStyle}>
            Setup and maintain your Staff Privileges
          </p>
          <div className={`${style.displayInRow}`}>
            <div style={{ marginRight: "40px" }}>
              <img
                src={WritingFile}
                className={style.dialogCrossStyle}
                alt="Writing File"
              />
            </div>
            <Icon
              icon="cross"
              size={30}
              intent={Intent.DANGER}
              className={style.dialogCrossStyle}
              onClick={() => {
                resetDialogFields();
                handleClose();
              }}
            />
          </div>
        </div>
        <div className={style.ReferenceListEntityBorder}></div>
        <div className={`${style.addHealthCareBoxStyle}`}>
          <Box display={"flex"} gap={3}>
            <Box width={"50%"} key={"department-service"}>
              <div className={style.entityLableStyle}>DEPARTMENT/SERVICE *</div>
              <FormControl fullWidth size="small">
                <Select
                  labelId="department-service-select"
                  id="department-service-select"
                  value={saveData.department ? saveData.department.id : ""}
                  onChange={handleDepartmentChange}
                  SelectDisplayProps={{
                    style: { paddingTop: 5, paddingBottom: 5, fontSize: 15 },
                  }}
                >
                  {departments.map((data, index) => (
                    <MenuItem value={data?.id} key={index}>
                      {data?.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <Box width={"50%"}>
              <div className={style.entityLableStyle}>SPECIFIC SITE*</div>
              <FormControl fullWidth size="small">
                <Select
                  labelId="specific-site-checkbox"
                  id="specific-site-checkbox"
                  value={
                    saveData.sites ? saveData.sites.map((item) => item.id) : []
                  }
                  multiple
                  onChange={handleSelectSiteChange}
                  SelectDisplayProps={{
                    style: { paddingTop: 5, paddingBottom: 5, fontSize: 15 },
                  }}
                >
                  {sites.map((data, index) => (
                    <MenuItem value={data?.id} key={index}>
                      {data?.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <Box width={"50%"}>
              <div className={style.entityLableStyle}>APPLICATION TYPE*</div>
              <FormControl fullWidth size="small">
                <Select
                  labelId="application-type-checkbox"
                  id="application-type-checkbox"
                  value={
                    saveData.applicantType ? saveData.applicantType.id : ""
                  }
                  onChange={handleApplicantTypeChange}
                  SelectDisplayProps={{
                    style: { paddingTop: 5, paddingBottom: 5, fontSize: 15 },
                  }}
                >
                  {applicantTypes?.map((data, index) => (
                    <MenuItem value={data?.id} key={index}>
                      {data?.type}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Box>
          <div className={`${style.marginTop20} ${style.validation}`}>
            <div className={style.entityLableStyle}>
              PRIVELEGE SPECIFICATION TYPE REQUIRED*
            </div>
            {privilegeSpecifications.map((item) => (
              <div className={`${style.marginLeft40} ${style.validation}`}>
                <FormControlLabel
                  control={
                    <Radio
                      id={item.id}
                      checked={item.value == privilegeSpecificationType}
                      onChange={handlePrivilegeSpecificationChange}
                      value={item.value}
                    />
                  }
                />
                <label>{item.label}</label>
              </div>
            ))}
          </div>

          {privilegeSpecificationType == PrivilegeSpecificationType1 && (
            <div className={`${style.validation} ${style.marginTop20}`}>
              <div className={style.entityLableStyle}>
                PROOF OF DOCUMENTATION REQUIRED?
              </div>
              <div>
                <FormControlLabel
                  control={
                    <Switch
                      checked={isProofOfDocumentRequired}
                      onChange={(e) => {
                        setIsProofOfDocumentRequired(e.target.checked);
                      }}
                      className={classes.switch}
                    />
                  }
                  className={`${style.switchFontStyle}`}
                  label={isProofOfDocumentRequired ? "Yes" : "No"}
                  labelPlacement="start"
                />
              </div>
            </div>
          )}
          <div className={style.marginTop20}>
            <div className={style.entityLableStyle}>
              GENERAL INSTRUCTION TEXT
            </div>
            <MarkdownEditor
              editorHtml={generalInstructionContent}
              onChange={(data) =>
                updateSaveData("generalInstructionText", data)
              }
              placeholder={"Enter GENERAL INSTRUCTION Here"}
            />
          </div>

          <div className={`${style.marginTop20} ${style.verticalAlignCenter}`}>
            <div className={style.entityLableStyle}>
              ADVANCED PRIVILEGES REQUIRED?
            </div>
            <div className={`${style.marginLeft10} ${style.marignbottom90}`}>
              <FormControlLabel
                control={
                  <Switch
                    checked={isPrivilagesRequired}
                    onChange={(e) => {
                      setPrivilagesRequired(e.target.checked);
                    }}
                    className={classes.switch}
                  />
                }
                className={`${style.switchFontStyle}`}
                label={isPrivilagesRequired ? "Yes" : "No"}
                labelPlacement="start"
              />
            </div>
            <div></div>
          </div>

          {isPrivilagesRequired && (
            <div className={`${style.marginTop20} ${style.padding5}`}>
              <div className={style.entityLableStyle}>
                ADVANCED PRIVILEGES SECTION INSTRUCTION TEXT
              </div>
              <Editor
                editorHtml={advancePrivilegeContent}
                onChange={(data) =>
                  updateSaveData("advancedInstructionText", data)
                }
                placeholder={
                  "Enter ADVANCED PRIVILEGES SECTION INSTRUCTION Here"
                }
              />
            </div>
          )}
          <div className={`${style.Borderthick} `}></div>

          <div className={style.marginTop20}>
            <div className={style.entityLableStyle}>BASIC PRIVILEGE</div>

            <div>
              {showCard && (
                <div
                  className={` ${style.cardContainer} ${style.padding10} `}
                  style={{ backgroundColor: "#bbb5f1" }}
                >
                  <div className={style.imageCard}>
                    <span className={style.categoryLabel}>(category)</span>
                    <div className={style.cardContent}>
                      <h3>12 Lorem ipsum dolor sit amet</h3>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed diam nonummy nibh euismod tincidunt ut laoreet
                        dolore magna.
                      </p>
                    </div>
                  </div>
                </div>
              )}
              <div
                className={` ${style.verticalAlignCenter} ${style.padding5}`}
              >
                <div
                  className={`${style.displayInRow}  ${style.entityLableStyle} `}
                >
                  CATERGORY?
                </div>

                <FormControlLabel
                  control={
                    <Switch
                      checked={writtenNotice}
                      onChange={(e) => setWrittenNotice(e.target.checked)}
                      className={classes.switch}
                    />
                  }
                  className={`${style.entityLableStyle} ${style.marginLeft20}`}
                  label={writtenNotice ? "YES" : "NONE"}
                  labelPlacement="start"
                />

                <div
                  style={{
                    marginLeft: "10px",

                    width: "100%",
                    overflow: "hidden",
                  }}
                >
                  {writtenNotice && (
                    <TextField
                      variant="outlined"
                      size="medium"
                      placeholder="Add Category Title"
                      className={`${style.inputField} `}
                      fullWidth
                    />
                  )}
                </div>
              </div>

              <div className={style.displayIn}>
                <div className={style.columnLayout}>
                  <div className={style.entityLabelStyle}>PRIVILEGE ID *</div>
                  <CommonInputField
                    placeholder="00"
                    className={style.inputField}
                    fullWidth
                  />
                </div>

                {/* PRIVILEGE TITLE Section */}
                <div className={style.columnLayout}>
                  <div className={style.entityLabelStyle}>
                    PRIVILEGE TITLE *
                  </div>
                  <CommonInputField
                    placeholder="Add Privilege Title"
                    className={style.inputField}
                    fullWidth
                  />
                </div>
              </div>

              {/* </div> */}
              <div className={style.entityLableStyle}>
                PRIVILEGE DESCRIPITION *
              </div>
              <CommonInputField
                // value={aliasName2}
                // onChange={(e) => setAliasName2(e.target.value)}
                className={`${style.inputField} `}
                fullWidth
              />
              <div
                className={`${style.floatRight} ${style.marginTop90} ${style.padding10}`}
              >
                <button
                  className={`${style.outlinedButton} ${style.borderRadius10}`}
                  onClick={handleAddMoreClick}
                >
                  ADD MORE
                </button>
              </div>
            </div>
          </div>
          <div
            className={`${style.Borderthick} ${style.marginTop60} ${style.padding10}`}
          />

          <div className={style.marginTop190}>
            <div className={style.entityLableStyle}>ADVANCED PRIVILEGE</div>

            <div>
              <div className={`  ${style.verticalAlignCenter}`}>
                <div
                  className={`${style.displayInRow}  ${style.entityLableStyle}`}
                >
                  CATERGORY?
                </div>

                <FormControlLabel
                  control={
                    <Switch
                      checked={advancedSwitch}
                      onChange={(e) => setAdvancedSwitch(e.target.checked)}
                      className={classes.switch}
                    />
                  }
                  className={`${style.entityLableStyle} ${style.marginLeft20}`}
                  label={advancedSwitch ? "YES" : "NONE"}
                  style={{ marginRight: "30px" }}
                  labelPlacement="start"
                />

                <div
                  style={{
                    marginLeft: "10px",

                    transition: "width 0.3s",
                    overflow: "hidden",
                  }}
                >
                  {advancedSwitch && (
                    <TextField
                      variant="outlined"
                      placeholder="Add Category Title"
                      fullWidth
                    />
                  )}
                </div>
              </div>

              <div className={style.displayIn}>
                <div className={style.columnLayout}>
                  <div className={style.entityLabelStyle}>PRIVILEGE ID *</div>
                  <CommonInputField
                    placeholder="00"
                    className={style.inputField}
                    fullWidth
                  />
                </div>

                <div className={style.columnLayout}>
                  <div className={style.entityLabelStyle}>
                    PRIVILEGE TITLE *
                  </div>
                  <CommonInputField
                    placeholder="Add Privilege Title"
                    className={style.inputField}
                    fullWidth
                  />
                </div>
              </div>
              <div className={style.entityLableStyle}>
                PRIVILEGE DESCRIPITION *
              </div>
              <CommonInputField
                // value={aliasName2}
                // onChange={(e) => setAliasName2(e.target.value)}
                className={`${style.inputField} `}
                fullWidth
              />
              <div className={`${style.floatRight} ${style.marginTop20}`}>
                <button
                  className={`${style.outlinedButton} ${style.borderRadius10}`}
                >
                  ADD MORE
                </button>
              </div>
            </div>
          </div>
          <div className={`${style.marginTop20} ${style.verticalAlignCenter}`}>
            <div className={style.entityLableStyle}>
              EVIDENCE OF QUALIFICATION AND COMPETENCY
            </div>
            <div className={style.marginLeft10}>
              <FormControlLabel
                control={
                  <Switch
                    checked={evidenceRequired}
                    onChange={(e) => {
                      setEvidenceRequired(e.target.checked);
                    }}
                    className={classes.switch}
                  />
                }
                className={`${style.switchFontStyle}`}
                label={evidenceRequired ? "Yes" : "No"}
                labelPlacement="start"
              />
            </div>
          </div>
          <div className={`${style.marginTop20} ${style.verticalAlignCenter}`}>
            <div className={style.entityLableStyle}>
              COMPETENCY DISCLOSURE NOTES
            </div>
            <div className={style.marginLeft10}>
              <FormControlLabel
                control={
                  <Switch
                    checked={competencyRequired}
                    onChange={(e) => {
                      setCompetencyRequired(e.target.checked);
                    }}
                    className={classes.switch}
                  />
                }
                className={`${style.switchFontStyle}`}
                label={competencyRequired ? "Yes" : "No"}
                labelPlacement="start"
              />
            </div>
            <div></div>
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div className={`${style.marginTop20} `} style={{ float: "left" }}>
            <button
              className={`${style.outlinedButton} ${style.borderRadius10}`}
              //   onClick={() => getAddEntityDialog(false)}
            >
              BULK UPLOAD
            </button>
            <button
              className={`${style.outlinedButton} ${style.borderRadius10} ${style.marginLeft20}`}
              //   onClick={() => getAddEntityDialog(false)}
            >
              PREVIEW
            </button>
          </div>
          <div className={`${style.floatRight} ${style.marginTop20}`}>
            <button
              className={`${style.outlinedButton} ${style.borderRadius10}`}
              onClick={() => SaveSubmitHandler(true)}
            >
              SAVE & EXIT
            </button>
            <button
              onClick={() => SaveSubmitHandler(false)}
              className={`${style.buttonStyle} ${style.marginLeft20} ${style.borderRadius10}`}
            >
              SAVE & ADD MORE
            </button>
          </div>
        </div>
      </div>
    </Dialog>
  );
};
export default StaffPrivilegeDialog;
